/**
 * Updates the mini basket on the page with new contents.
 * @param {any} response - The response object containing updated basket HTML.
 */
export function updateMiniBasket(response: any): void {
	const miniBasket = document.querySelector('#mini-basket .mini-basket-contents');
	// @ts-ignore
	miniBasket.innerHTML = response.miniBasketHtml;
}
